import { render, staticRenderFns } from "./RoomDescription.vue?vue&type=template&id=80cd0d04&"
import script from "./RoomDescription.vue?vue&type=script&lang=ts&"
export * from "./RoomDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports